function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "80l1815ida"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4466",
    transform: "translate(39 317)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bpcw50yh2b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 28492",
    transform: "translate(0 .105)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icn/evoucher",
    transform: "translate(-39 -317)",
    style: {
      clipPath: "url(#80l1815ida)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79259"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79258",
    transform: "translate(41 318.894)",
    style: {
      clipPath: "url(#bpcw50yh2b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66165",
    d: "M74.94 0h-.109A1.7 1.7 0 0 0 73.2 1.289a1.683 1.683 0 0 1-3.247 0A1.7 1.7 0 0 0 68.317 0h-.109A4.213 4.213 0 0 0 64 4.208v13.465a2.525 2.525 0 0 0 2.525 2.527h1.793a1.7 1.7 0 0 0 1.633-1.289 1.683 1.683 0 0 1 3.247 0 1.7 1.7 0 0 0 1.633 1.289h1.793a2.525 2.525 0 0 0 2.525-2.525V4.208A4.213 4.213 0 0 0 74.94 0m1.683 18.514-1.8-.053a3.366 3.366 0 0 0-6.5.053h-1.798a.842.842 0 0 1-.842-.842v-3.366h1.683a.842.842 0 1 0 0-1.683h-1.683V4.208a2.525 2.525 0 0 1 2.525-2.525l.12.053a3.375 3.375 0 0 0 3.246 2.472 3.426 3.426 0 0 0 3.276-2.525h.09a2.525 2.525 0 0 1 2.525 2.525v8.416h-1.683a.842.842 0 1 0 0 1.683h1.683v3.366a.842.842 0 0 1-.842.842",
    transform: "translate(-61.588 .021)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66166",
    d: "M215.858 320h-1.683a.842.842 0 0 0 0 1.683h1.683a.842.842 0 1 0 0-1.683",
    transform: "translate(-205.03 -307.356)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoucher);
export default __webpack_public_path__ + "static/media/evoucher.f1b9864a8f17ef9f498521772253ad11.svg";
export { ForwardRef as ReactComponent };